// extracted by mini-css-extract-plugin
export default {"localization":"s6l0P6VLHOljSxE89x_b","heading":"DjYr8COmmbgAAti5y9kA","selectBy":"Z5FQhC6QEoe46kGJHevG","select":"HlvlpnuKNwtRkd2tey0V","fade-in":"KrT8bbw2onyMMIZKsTF5"};